'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Common.NotificationModal', dependencies).directive('rmNotificationModal', require('./directives/NotificationModalDirective'));